import { Loader } from '@grafikr/components';
import { isbot } from 'isbot';

import { getCurrentUri, getIntendedSite, getUserCountry, isOnIntendedSite } from 'utils/geo';

export default Loader((_, load) => {
  // Return early if user agent is a bot
  if (isbot(navigator.userAgent)) {
    return;
  }

  // Return early if already on intended site
  if (isOnIntendedSite()) {
    return;
  }

  const checkRegion = async () => {
    const currentUri = getCurrentUri();
    const currentCountry = await getUserCountry();
    const regionMatch = getIntendedSite(currentCountry);

    if ('uri' in regionMatch) {
      if (regionMatch.uri !== currentUri) {
        load();
      }
    } else {
      load();
    }
  };

  if (!window.hasDecidedConsent) {
    document.addEventListener('trackingConsentAccepted', checkRegion, { once: true });
  } else {
    checkRegion();
  }

  return () => {};
});
